import React from 'react';

import ForgotPasswordForm from './components/ForgotPasswordForm';

const ForgotPasswordPage = () => <ForgotPasswordForm />;

export default ForgotPasswordPage;
